const currentYear = new Date().getFullYear();

export const ISO_DATE_FORMAT = "MM/dd/yyyy";

export const DEFAULT_FILTERS = {
  year: currentYear,
};

export const BASE_URL = `${process.env.REACT_APP_ENDPOINT}/api/climate-center`;
